module.exports = __webpack_public_path__ + "static/img/commodity_sing04.65cce47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/malls/commodity_sing04.png
// module id = WXNM
// module chunks = 174